import { graphql, useStaticQuery } from "gatsby";
import { useEffect } from "react";
import { useConsent } from "./ConsentContext";
import {
  loadAdRoll,
  loadElfsightPlatform,
  loadFacebookPixel,
  loadGoogleAnalytics,
} from "./loadScripts";
import { resolveTrackingIds } from "./trackingIds";

export const ConsentScripts = () => {
  const { hasChoice, hydrated, consent } = useConsent();
  const { site } = useStaticQuery(graphql`
    query ConsentTrackingIds {
      site {
        siteMetadata {
          gaAnalyticsId
          fbPixelId
        }
      }
    }
  `);

  const { gaAnalyticsId, fbPixelId } = resolveTrackingIds(
    site?.siteMetadata || {}
  );

  useEffect(() => {
    // Wait for localStorage consent hydrate so we don't miss a prior Accept.
    if (!hydrated || !hasChoice) return;

    if (consent.analytics) {
      loadGoogleAnalytics(gaAnalyticsId);
    }

    if (consent.marketing) {
      // FB first, then AdRoll — avoids AdRoll owning fbq before our init.
      loadFacebookPixel(fbPixelId);
      loadAdRoll();
      loadElfsightPlatform();
    }
  }, [
    hydrated,
    hasChoice,
    consent.analytics,
    consent.marketing,
    gaAnalyticsId,
    fbPixelId,
  ]);

  return null;
};
